import * as R from "ramda";
import { parseDefaultAnnotation } from "./parseDefaultAnnotation.mjs";
import { parseDataParams } from "./parseDataParams.mjs";
const getDefaultDataParams = (structure) => R.pipe(parseDefaultAnnotation, parseDataParams)(structure);
export {
  getDefaultDataParams
};
